import { fromConsultationPreviewDataList } from './ConsultationPreviewData.js';
import { fromDocumentPreviewDataList } from './DocumentPreviewData.js';
import { fromPatientCodesData } from './PatientCodesData.js';
import { fromPatientData } from './PatientData.js';
import { fromPatientReferralDataList } from './PatientReferralData.js';
import { requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.patient.PatientRecord
 *
 * @typedef {object} PatientRecordData
 * @property {import('./PatientData.js').PatientData|null} patient
 * @property {import('./PatientCodesData.js').PatientCodesData|null} patientCodesData
 * @property {import('./DocumentPreviewData.js').DocumentPreviewData[]} documentPreviews
 * @property {import('./ConsultationPreviewData.js').ConsultationPreviewData[]} consultationPreviews
 * @property {import('./PatientReferralData.js').PatientReferralData[]} pendingReferrals
 */

/**
 * @param {object} raw
 * @returns {PatientRecordData}
 */
export function fromPatientRecordData(raw) {
  const source = requireObject(raw, 'PatientRecord');
  return {
    patient: source.patient == null ? null : fromPatientData(source.patient),
    patientCodesData: source.patientCodesData == null ? null : fromPatientCodesData(source.patientCodesData),
    documentPreviews: fromDocumentPreviewDataList(source.documentPreviews),
    consultationPreviews: fromConsultationPreviewDataList(source.consultationPreviews),
    pendingReferrals: fromPatientReferralDataList(source.pendingReferrals),
  };
}
